import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';

import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';

import { NgIf } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { EMAIL_EXP, LayoutService, injectEnvironment } from '@cf/core';
import { GoogleAuthComponent, MicrosoftAuthComponent } from '@cf/features/auth/shell';
import {
  FormFieldComponent,
  InputDirective,
  InputErrorComponent,
  InputPrefixDirective,
  LabelComponent,
} from '@cf/shared/forms/form-field';
import { PasswordInputComponent } from '@cf/shared/forms/form-widgets';
import { ButtonComponent, LinkComponent } from '@cf/shared/ui/button';
import { CfIconDirective } from '@cf/shared/ui/icons';
import { LoaderContainerComponent } from '@cf/shared/ui/loading';
import { TextComponent } from '@cf/shared/ui/typography';
import { AuthService, LoginCredentialsDto } from '@cf/temp/services';
import { NgxTolgeeModule } from '@tolgee/ngx';
import { fadeInOnEnterAnimation, fadeInRightOnEnterAnimation } from 'angular-animations';

@Component({
  selector: 'cf-booking-login',
  templateUrl: 'booking-login.component.html',
  styleUrl: 'booking-login.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [fadeInRightOnEnterAnimation(), fadeInOnEnterAnimation()],
  imports: [
    LoaderContainerComponent,
    NgxTolgeeModule,
    TextComponent,
    GoogleAuthComponent,
    MicrosoftAuthComponent,
    ReactiveFormsModule,
    InputDirective,
    InputPrefixDirective,
    LabelComponent,
    InputErrorComponent,
    FormFieldComponent,
    PasswordInputComponent,
    ButtonComponent,
    LinkComponent,
    NgIf,
    CfIconDirective,
  ],
})
export class BookingLoginComponent implements OnInit, OnDestroy {
  @ViewChild('passInput') private passInput?: PasswordInputComponent;

  showErrorMsg = false;

  loginForm: FormGroup = this.formBuilder.group({
    email: new FormControl<string>('', [
      Validators.required,
      Validators.email,
      Validators.pattern(EMAIL_EXP),
    ]),
    password: new FormControl<string>('', [Validators.required]),
  });

  private environment = injectEnvironment();

  constructor(
    private readonly layoutService: LayoutService,
    private readonly formBuilder: FormBuilder,
    private readonly authService: AuthService,
    private readonly route: ActivatedRoute,
  ) {}

  get email() {
    return this.route.snapshot.queryParams['email'];
  }

  get disableEmail() {
    return this.route.snapshot.queryParams['disableEmail'];
  }

  ngOnInit() {
    this.authService.isBookingApp = true;

    this.layoutService.hideHeader.next(true);

    if (this.email) {
      this.loginForm.controls['email'].patchValue(this.email);
    }

    if (this.disableEmail) {
      this.loginForm.controls['email'].disable();
    }
  }

  ngOnDestroy() {
    this.layoutService.hideHeader.next(false);
  }

  login(): void {
    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      this.passInput?.password.markAllAsTouched();
      return;
    }
    this.authService.login(new LoginCredentialsDto(this.loginForm.getRawValue())).subscribe({
      next: (res) => {
        if (res.access) {
          // this.activeModal.close();
        }
      },
      error: () => {
        this.showErrorMsg = true;
      },
    });
  }

  forgotPasswordRedirect(): void {
    window.open(`${this.environment.appUrl}/auth/forgot-password`, '_blank');
  }
}
